var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecipientUnique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.68 24C42.68 26.3684 44.6003 28.2888 46.9688 28.2888V39.3443H1.03125V28.2888C3.39966 28.2888 5.32003 26.3684 5.32003 24C5.32003 21.6316 3.39966 19.7112 1.03125 19.7112V8.65576H46.9688V19.7112C44.6004 19.7112 42.68 21.6317 42.68 24Z",
    stroke: "black",
    strokeWidth: 2.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1489 16.015L21.7434 21.272L27.5449 22.115L23.3469 26.2071L24.338 31.9851L19.1489 29.257L13.9599 31.9851L14.951 26.2071L10.7529 22.115L16.5545 21.272L19.1489 16.015Z",
    stroke: "#4F4FAB",
    strokeWidth: 2.0625,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1123 12.8568V8.65576",
    stroke: "black",
    strokeWidth: 2.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1123 21.6251V18.5598",
    stroke: "black",
    strokeWidth: 2.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1123 30.3933V27.3279",
    stroke: "black",
    strokeWidth: 2.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1123 39.3443V36.0963",
    stroke: "black",
    strokeWidth: 2.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientUnique);
export default __webpack_public_path__ + "static/media/recipient_unique.fcc40146ba17237d387101559bada56d.svg";
export { ForwardRef as ReactComponent };